import { FC } from "react";
import { FEEDBACK_TYPES } from "../../constants/feedbacks";
import useI18n from "../../hooks/useTranslations";
import { FeedbackType } from "../../http/types/feedbacks";
import { useFeedbacksApi } from "../../http/useFeedbacks";
import SupportRequestDialog, { SupportRequestCapture } from "./SupportRequestDialog";

interface FeedbackDialogProps extends SupportRequestCapture {
  onClose: () => void;
}

/** Feedback of the test users, sent to the developer and the project manager. */
const FeedbackDialog: FC<FeedbackDialogProps> = ({ screenshot, diagnostics, onClose }) => {
  const i18n = useI18n();
  const feedbacksApi = useFeedbacksApi();

  return (
    <SupportRequestDialog
      texts={{
        title: i18n.translation.feedbacks.dialogTitle,
        intro: i18n.translation.feedbacks.intro,
        success: i18n.translation.feedbacks.success,
      }}
      typeOptions={FEEDBACK_TYPES.map((value) => ({ value, label: i18n.translation.feedbacks.types[value] }))}
      // the type is required by the dialog when typeOptions are set
      send={(body) => feedbacksApi.sendFeedback({ ...body, type: body.type as FeedbackType })}
      screenshot={screenshot}
      diagnostics={diagnostics}
      onClose={onClose}
    />
  );
};

export default FeedbackDialog;
